<!--阳西荔枝-->
<template>
 <div class='container' :style='style'>
   <div class='top'>
        <div class='weather-section'>
          <chart-box>
             <Wheather :countyId="countyId"/>
          </chart-box>
         </div>
        <div class='title-img'>
          <img src='//img.yimutian.com/crm/5ec38e692d211f581e057af303220045.png'/>
          <div class="tab_cantainer flex">
            <router-link to="/yangxi/data/8048" v-cloak class="btn_primary" :class="{ btn_on: currentTabType === 'litchi' }">
              荔枝
              <div class="mask"></div>
            </router-link>
            <router-link to="/yangxi/data/9008" v-cloak class="btn_primary" :class="{ btn_on: currentTabType === 'oyster' }">
              生蚝
              <div class="mask"></div>
            </router-link>
          </div>
        </div>
        <div class='logo-section'>
          <img class="logo-yangxi" src="//img.yimutian.com/crm/5ebd1632b8277368a201b7f3004d005c.png" alt="">
          <img class="logo-liantong" src="//img.yimutian.com/crm/5ebd1746b8277368a201b8db00780042.png" >
          <img class="logo-ymt" @click="goHome" src="//img.yimutian.com/crm/5ebd17eab8277368a201b9810076002e.png">
        </div>
   </div>
   <div class='bottom'>
      <div class='left-section'>
            <div class='left-top'>
              <div class='rank-provider'>
                  <div class='block-title title-back-one'>
                     <span class='block-big-title'>最受欢迎的供应商</span>
                  </div>
                  <div class='block-sub-title'>
                     最受采购商欢迎的{{currentAddr}}{{currentPropductName}}供应商TOP30
                  </div>
                  <div class='rank-provider-container'>
                        <chart-box>
                           <PopularProvider :productId="productId" :countyId="countyId"/>
                       </chart-box>
                  </div>
              </div>

               <div class='capture-rate'>
                  <div  class='block-title title-back-one'>
                     <span class='block-big-title'>采购渗透率</span>
                  </div>
                  <div class='block-sub-title'>
                     全国{{currentPropductName}}地级行政区渗透率+全国{{currentPropductName}}采购商渗透率
                  </div>
                  <div class='rate-container'>
                       <!--采购渗透率-->
                        <chart-box>
                          <div class='top-ration'>
                            <div class='ration-city'>
                                <BuyerRationCity :productId="productId" :countyId="countyId"/>
                            </div>
                            <div class='ration-person'>
                              <BuyerRationPerson :productId="productId" :countyId="countyId"/>
                                <!-- <buyerRationPerson></buyerRationPerson> -->
                            </div>
                           </div>
                           <div class='bottom-ration'>
                              <div class='ration-words'>
                                地级行政区渗透率：{{currentAddr}}{{currentPropductName}}在全国地级行政区的渗透率<br/>
                                采购商渗透率：{{currentAddr}}{{currentPropductName}}在全国{{currentPropductName}}采购商中的渗透率
                              </div>
                           </div>
                       </chart-box>
                  </div>
              </div>
            </div>

            <div class='left-middle'>
                  <div class='block-title single-line-title title-back-two'>
                     <span class='block-big-title'>供应热度</span>
                     <span class='block-big-sub-title'>·{{currentAddr}}{{currentPropductName}}供应信息发布次数</span>
                  </div>
                  <div class='hot-degree'>
                     <!--供应热度-->
                      <chart-box>
                        <ProvideHot :productId="productId" :countyId="countyId"/>
                      </chart-box>
                  </div>
            </div>
            <div class='left-bottom'>
                 <div class='block-title single-line-title title-back-three'>
                     <span class='block-big-title'>采购商指数</span>
                     <span class='block-big-sub-title'>·由{{currentAddr}}{{currentPropductName}}采购商的搜索、查看、联系下单等行为数据构成，旨在反应{{currentAddr}}{{currentPropductName}}的市场采购热度</span>
                  </div>
                  <div class='hot-degree'>
                      <!--采购商指数-->
                       <chart-box>
                          <BuyerData :productId="productId" :countyId="countyId"/>
                       </chart-box>
                  </div>
            </div>
      </div>
      <div class='middle-section'>
            <div class='middle-title'>
                  <div class='block-title title-back-one'>
                     <span class='block-big-title'>销售流向</span>
                  </div>
                  <div class='block-sub-title'>
                     {{currentAddr}}{{currentPropductName}}的采购商来源分布
                  </div>
            </div>
            <div class='middle-map'>
               <!--中国地图-->
               <chart-box>
                   <ChinaMap :productId="productId" :countyId="countyId"/>
               </chart-box>
            </div>
      </div>
      <div class='right-section'>
            <div class='right-top'>
                  <div class='block-title  title-back-four'>
                     <span class='block-big-title'>平台综合价格</span>
                  </div>
                  <div class='block-sub-title clearfix'>
                    {{currentAddr}}{{currentPropductName}}的平台综合价格（元/斤）
                     <TabBar v-if="currentTabType === 'litchi'" :list="tagList" :limit="4" defaultValue="妃子笑" @change="tabChange" class="pull-right"/>
                  </div>
                  <div class='place-price'>
                     <!--产地价格-->
                       <chart-box>
                         <ProductOriginPrice :productId="ymtAverageProductId" :secondProductId="ymtAverageProductId" :countyId="countyId"/>
                       </chart-box>
                  </div>
            </div>
            <div class='right-middle'>
                  <div class='block-title single-line-title title-back-five'>
                     <span class='block-big-title'>批发市场综合价格</span>
                     <span class='block-big-sub-title'>全国批发市场的{{currentAddr}}{{currentPropductName}}综合价格（元/斤）</span>
                     <TabBar v-if="currentTabType === 'litchi'" :list="tagList" :limit="4" defaultValue="妃子笑" @change="tabMarkChange" class="pull-right mark_tab"/>
                  </div>
                  <div class='market-price'>
                     <!--市场价格+规格-->
                       <chart-box>
                          <MarketPrice :productId="saleAverageProductId" :secondProductId="saleAverageProductId" :countyId="countyId"/>
                       </chart-box>
                  </div>
            </div>
            <div class='right-bottom'>
                  <div class='block-title single-line-title title-back-six'>
                     <span class='block-big-title'>热门采购城市</span>
                     <span class='block-big-sub-title'>·本年度{{currentAddr}}{{currentPropductName}}采购商来源城市TOP30，以及去年同期对比</span>
                  </div>
                  <div class='hot-city'>
                     <!--热门采购城市-->
                       <chart-box>
                           <HotCity :productId="productId" :countyId="countyId"/>
                       </chart-box>
                  </div>
            </div>
       </div>
   </div>
 </div>
</template>

<script>
import { mapState } from 'vuex'
import { http } from '@/http'
import Wheather from '@/components/Wheather/index.vue' // 天气组件
import PopularProvider from '@/components/PopularProvider/index.vue'
import ChinaMap from '@/components/ChinaMap/index.vue'
import BuyerRationCity from '@/components/BuyerRationCity/index.vue'// 采购渗透率
import BuyerRationPerson from '@/components/BuyerRationPerson/index.vue'
import ProvideHot from '@/components/ProvideHot/index.vue'
import BuyerData from '@/components/BuyerData/index.vue'// 供应商指数
import ProductOriginPrice from '@/components/ProductOriginPrice/index.vue'// 产地价格
import MarketPrice from '@/components/MarketPrice/index.vue'
import HotCity from '@/components/HotCity/index.vue'// 市场价格
import ChartBox from '@/components/ChartBox/index.vue' // 图表外框
import TabBar from '@/components/TabBar/index.vue'

export default {
  data () {
    return {
      style: {},
      // 默认阳西荔枝
      countyId: 2215,
      productId: 0, // 8048 荔枝 9008 生蚝
      currentAddr: '阳西',
      currentPropductName: '荔枝',
      currentTabType: 'litchi',
      tagCofnig: [],
      ymtAverageProductId: 7495,
      saleAverageProductId: 7495,
      tagList: null
    }
  },
  components: {
    ChinaMap,
    ChartBox,
    ProvideHot,
    BuyerData,
    BuyerRationCity,
    BuyerRationPerson,
    ProductOriginPrice,
    MarketPrice,
    HotCity,
    Wheather,
    PopularProvider,
    TabBar
  },
  computed: {
    ...mapState({
      isVIP: state => state.user.isVIP
    })
  },
  methods: {
    // 页面适配
    setPageScale () {
      let winW = parseInt(document.body.clientWidth)
      let winH = parseInt(document.body.clientHeight)
      let ratioW = winW / 4088
      let ratioH = winH / 1730
      this.style = {
        transformOrigin: 'left top',
        transform: `scale(${ratioW},${ratioH})`
      }
      if (this.$route.params && this.$route.params.product_id) {
        let obj = { litchi: { name: '荔枝', id: 8048 }, oyster: { name: '生蚝', id: 9008 } }
        this.currentTabType = this.$route.params.product_id && this.$route.params.product_id - '' === 9008 ? 'oyster' : 'litchi'
        this.currentPropductName = obj[this.currentTabType].name
        this.productId = obj[this.currentTabType].id
        if (this.currentTabType === 'oyster') {
          this.saleAverageProductId = this.productId
          this.ymtAverageProductId = this.productId
        } else if (this.tagList && this.tagList.length) {
          const o = this.tagList[0]
          this.saleAverageProductId = o.id
          this.ymtAverageProductId = o.id
        }
      }
    },
    goHome () {
      if (!this.isVIP) return
      this.$router.replace({
        name: 'home',
        query: {
          province_id: 20
        }
      })
    },
    tabChange (t) {
      this.ymtAverageProductId = t.id
    },
    tabMarkChange (t) {
      this.saleAverageProductId = t.id
    }
  },
  created () {
    http.get('/canmou/tianji/product/product_list?county_id=' + this.countyId).then(res => {
      let resData = res.data.data || []
      this.tagList = resData
      if (this.tagList.length) {
        this.saleAverageProductId = this.tagList[0].id
        this.ymtAverageProductId = this.tagList[0].id
      }
    })
  },
  mounted () {
    this.setPageScale()
  },
  watch: {
    $route (to) {
      console.log('to')
      if (to.params && to.params.product_id) {
        let obj = { litchi: { name: '荔枝', id: 8048 }, oyster: { name: '生蚝', id: 9008 } }
        this.currentTabType = to.params.product_id && to.params.product_id - '' === 9008 ? 'oyster' : 'litchi'
        this.currentPropductName = obj[this.currentTabType].name
        this.productId = obj[this.currentTabType].id
        if (this.currentTabType === 'oyster') {
          this.saleAverageProductId = this.productId
          this.ymtAverageProductId = this.productId
        } else {
          const o = this.tagList[0]
          this.saleAverageProductId = o.id
          this.ymtAverageProductId = o.id
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.ration-words{
   text-align:left;
   color:#0efcff;
}
.top-ration{
   width:100%;
   height:344px;
}
.bottom-ration{
   width:100%;
   height:80px;
   line-height:25px;
   font-size:20px;
   color:#4c6397;
   padding-left:45px;
}
.ration-city,.ration-person{
   position:relative;
   float:left;
   width:50%;
   height:344px;
}

.title-back-one{
   background:url(http://img.yimutian.com/crm/5d9169212d211f714f03890bd0c868bb.png) left center no-repeat;
   background-size:contain;
}
.title-back-two{
    background:url(http://img.yimutian.com/crm/5d916a032d211f714f038998aad145b8.png) left center no-repeat;
    background-size:contain;
}
.title-back-three{
    background:url(http://img.yimutian.com/crm/5d916a572d211f714f0389dff30e2cf0.png) left center no-repeat;
    background-size:contain;
}
.title-back-four{
    background:url(http://img.yimutian.com/crm/5d916a702d211f714f0389fa35b388d9.png) left center no-repeat;
    background-size:contain;
}
/*市场价格规格*/
.title-back-five{
    background:url(http://img.yimutian.com/crm/5d916a932d211f714f038a04481a6392.png) left center no-repeat;
    background-size:contain;
}
.title-back-six{
    background:url(http://img.yimutian.com/crm/5d916ade2d211f714f038a1cd97844a7.png) left center no-repeat;
    background-size:contain;
}
.title-img{
   display:inline-block;
   margin-top:39px;
}
.title-img img {
  height:60px;
  width:auto;
}
.title-section{
   text-align:center;
   position:absolute;
   height:100%;
   left:772px;
   right:175px;
   background:url(http://img.yimutian.com/crm/5d916755b827736e3b0387c8a34a6139.png) center center no-repeat;
   background-size:auto 100%;
}
.weather-section{
   position:absolute;
   left:36px;
   top:46px;
   width:850px;
   height:60px;
}
.logo-section{
   position:absolute;
   right:26px;
   top:46px;
   img {
     width: auto;
     display: inline-block;
     vertical-align: middle;
     margin-right: 32px;
   }
   .logo-ymt {
     width: 118px;
     cursor: pointer;
   }
   .logo-yangxi {
     width: 77px;
   }
   .logo-liantong {
     width: 120px;
   }
}
.single-line-title{
  margin-bottom:24px;
}
.right-top{
  height:539px;
  width:100%;
  margin-bottom:22px;

}

.right-middle{
   height:462px;
   width:100%;
   margin-bottom:22px;
}
.middle-map{
  width:100%;
  height:1380px;
  position:relative;
}
.place-price{
   height:410px;
}
.hot-city{
   height:370px;
   position:relative;
}
.hot-degree{
   height:365px;
   position:relative;
}
.market-price{
    height:370px;
}
.left-bottom{
  height:455px;
  width:100%;
}
.left-middle{
   width:100%;
   height:445px;
   margin-bottom:22px;
}
.capture-rate{
   margin-left:30px;
}
.rank-provider-container,.rate-container{
  width:100%;
  height:431px;
}

.rank-provider{
   width:670px;
   height:556px;
   float:left;
}
.capture-rate{
   width:600px;
   height:581px;
   padding-bottom:25px;
   float:left;
}
.block-title{
   height:67px;
   line-height:67px;
   width:100%;
   padding-left:30px;
}
.block-sub-title{
  //  height:60px;
  line-height:60px;
  height: 60px;
  width:100%;
  font-size:20px;
  color:#0efcff;
}
.block-big-title{
   font-size:30px;
   color:#0dffff;
}
.block-big-sub-title{
   font-size:20px;
   color:#0dffff;
}

.left-top{
  width:100%;
  box-sizing:border-box;
  height:559px;
  margin-bottom:25px;
}
html,body{
  width:100%;
  height:100%
}
.container{
  width:4088px;
  height:1730px;
  background: url(http://img.yimutian.com/crm/5d9171f22d211f714f038edf4f7a4e65.jpeg) left top no-repeat;
  background-size:cover;
  font-family: 'PingFang SC', Microsoft YaHei;
}
.top{
  position:relative;
  width:100%;
  height:200px;
  background:url(http://img.yimutian.com/crm/5ebbb4902d211f581e00d9ab0c3f00cf.png) center center no-repeat;
  background-size:contain;
  text-align:center;
}

.bottom{
  width:100%;
  height:1545px;
}
.bottom>div{
  float:left;
  height:1509px;
  margin-left:28px;
  over-flow:hidden;
}
.left-section{
  width:1300px;
}
.middle-section{
  width:1376px;
}
.right-section{
  width:1300px;
}
.tab_cantainer {
  margin-top: 21px;
}
.flex {
  display: flex;
  justify-content: center;
}
.btn_primary {
  width: 372px;
  height: 70px;
  border:2px solid rgba(13,203,242,1);
  font-size: 40px;
  font-weight:bold;
  color:rgba(0,255,255,1);
  line-height: 70px;
  cursor: pointer;
  position: relative;
  border-bottom: 0px;
  z-index: 99;
  overflow: hidden;
  &:first-child {
    border-left: 0px;
    .mask {
      width:100%;
      height:30px;
      box-sizing: content-box;
      border-top: 45px solid #00ffff;
      border-left: 78px solid transparent;
      position: absolute;
      top: 23px;
      left: -8px;
      border-radius: 13px;
      border-top-right-radius: 0px;
      z-index: -1;
      display: none;
    }
    &::before {
      content: '';
      display: inline-block;
      position: absolute;
      top:0px;
      left: 0px;
      height: 26px;
      width: 100%;
      background: #00ffff;
      z-index: -1;
      display: none;
    }
    &::after {
      content: '';
      display: inline-block;
      position: absolute;
      top: -2px;
      left: 0px;
      width: 2px;
      height: 30px;
      background: rgba(13,203,242,1);
    }
  }
  &:last-child {
    border-right: 0px;
    .mask {
      width:81%;
      height:30px;
      box-sizing: content-box;
      border-top: 45px solid #00ffff;
      border-right: 84px solid transparent;
      position: absolute;
      top: 22px;
      left: -7px;
      border-radius: 13px;
      border-top-left-radius: 0px;
      z-index: -1;
      display: none;
    }
    &::before {
      content: '';
      display: inline-block;
      position: absolute;
      top:0px;
      left: 0px;
      height: 24px;
      width: 100%;
      background: #00ffff;
      z-index: -1;
      display: none;
    }
    &::after {
      content: '';
      display: inline-block;
      position: absolute;
      top: -2px;
      right: 0px;
      width: 2px;
      height: 30px;
      background: rgba(13,203,242,1);
    }
  }
}
.btn_on {
  // background: #0dcbf2;
  color: #060e1e;
  &::before {
    display: block !important;
  }
  .mask {
    display: block !important;
  }
}
.pull-right {
  float: right;
}
.clearfix {
  &:after {
    content: "";
    display: table;
    clear: both;
  }
}
.mark_tab {
  margin-top: 10px;
}
</style>
